import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import { useAppSelector } from 'hooks/reduxHooks'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import LuxPlusManageAccountModalMembershipCancellation from './LuxPlusManageAccountModalMembershipCancellation'
import LuxPlusManageAccountModalOverview from './LuxPlusManageAccountModalOverview'
import LuxPlusManageAccountModalRenewalCancellation from './LuxPlusManageAccountModalRenewalCancellation'
import LuxPlusManageAccountModalRenewalCancellationConfirmation from './LuxPlusManageAccountModalRenewalCancellationConfirmation'
import LuxPlusManageAccountModalRenewalCancellationSuccess from './LuxPlusManageAccountModalRenewalCancellationSuccess'
import LuxPlusManageAccountModalRenewalReactivation from './LuxPlusManageAccountModalRenewalReactivation'
import LuxPlusManageAccountModalRenewalReactivationSuccess from './LuxPlusManageAccountModalRenewalReactivationSuccess'
import LuxPlusManageAccountModalUpdatePaymentMethod from './LuxPlusManageAccountModalUpdatePaymentMethod'
import LuxPlusManageAccountModalUpdatePaymentMethodFailure from './LuxPlusManageAccountModalUpdatePaymentMethodFailure'
import LuxPlusManageAccountModalUpdatePaymentMethodSuccess from './LuxPlusManageAccountModalUpdatePaymentMethodSuccess'

type ManageMode =
  | 'overview'
  | 'membership-cancellation'
  | 'renewal-cancellation'
  | 'renewal-cancellation-confirmation'
  | 'renewal-cancellation-success'
  | 'renewal-reactivation'
  | 'renewal-reactivation-success'
  | 'payment-method-update'
  | 'payment-method-update-success'
  | 'payment-method-update-failure'

function LuxPlusManageAccountModal() {
  const intl = useIntl()
  const [mode, setMode] = useState<ManageMode>('overview')

  const { item } = useAppSelector(state => state.auth.account.luxPlus.member.subscription)

  const isLoyaltyEnabled = useAppSelector(getIsLoyaltyEnabled)

  return <ModalBase size="S" height="max" tabletHeight="auto">
    {!item && <ModalContent>
      <ModalBody>
        <LoadingIndicator inline>{intl.formatMessage({
          id: 'p8Cm7g3Ju1H67rSjBhKW',
          defaultMessage: 'Fetching account information',
          description: 'Loading indicator text while fetching account subscription data',
        })}
        </LoadingIndicator>
      </ModalBody>
    </ModalContent>}
    {!!item && <>
      {mode === 'overview' && <LuxPlusManageAccountModalOverview
        item={item}
        onCancelMembership={() => setMode('membership-cancellation')}
        onCancelRenew={() => setMode('renewal-cancellation-confirmation')}
        onReactivateRenew={() => setMode('renewal-reactivation')}
        onUpdatePaymentMethod={() => setMode('payment-method-update')}
      />}
      {mode === 'membership-cancellation' && <LuxPlusManageAccountModalMembershipCancellation
        onBack={() => setMode('overview')}
      />}
      {mode === 'renewal-cancellation-confirmation' && <LuxPlusManageAccountModalRenewalCancellationConfirmation
        item={item}
        onCancelRenewal={() => setMode('renewal-cancellation')}
        onBack={() => setMode('overview')}
      />}
      {mode === 'renewal-cancellation' && <LuxPlusManageAccountModalRenewalCancellation
        item={item}
        onRenewCancelSuccess={() => setMode('renewal-cancellation-success')}
        onBack={() => setMode('overview')}
      />}
      {mode === 'renewal-cancellation-success' && <LuxPlusManageAccountModalRenewalCancellationSuccess
        item={item}
        onBack={() => setMode('overview')}
      />}
      {mode === 'renewal-reactivation' && <LuxPlusManageAccountModalRenewalReactivation
        item={item}
        onReactivationSuccess={() => isLoyaltyEnabled ? setMode('renewal-reactivation-success') : setMode('overview')}
        onBack={() => setMode('overview')}
      />}
      {mode === 'renewal-reactivation-success' && <LuxPlusManageAccountModalRenewalReactivationSuccess
        item={item}
        onBack={() => setMode('overview')}
      />}
      {mode === 'payment-method-update' && <LuxPlusManageAccountModalUpdatePaymentMethod
        item={item}
        onUpdatePaymentMethodSuccess={() => setMode('payment-method-update-success')}
        onUpdatePaymentMethodFailure={() => setMode('payment-method-update-failure')}
        onBack={() => setMode('overview')}
      />}
      {mode === 'payment-method-update-success' && <LuxPlusManageAccountModalUpdatePaymentMethodSuccess
        onBack={() => setMode('overview')}
      />}
      {mode === 'payment-method-update-failure' && <LuxPlusManageAccountModalUpdatePaymentMethodFailure
        onBack={() => setMode('payment-method-update')}
      />}
    </>}
  </ModalBase>
}

export default LuxPlusManageAccountModal
